import { Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { NotFoundComponent } from './common/not-found/not-found.component';
import { AuthenticationComponent } from './authentication/authentication.component';
import { SignInComponent } from './authentication/sign-in/sign-in.component';
import { SignUpComponent } from './authentication/sign-up/sign-up.component';
import { ForgotPasswordComponent } from './authentication/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './authentication/reset-password/reset-password.component';
import { LockScreenComponent } from './authentication/lock-screen/lock-screen.component';
import { LogoutComponent } from './authentication/logout/logout.component';
import { ConfirmEmailComponent } from './authentication/confirm-email/confirm-email.component';
import { MyProfileComponent } from './my-profile/my-profile.component';
import { authGuard } from './shared/auth.guard'
import { NotAuthorizedComponent } from './common/not-authorized/not-authorized.component';
import { ViewApplicationLogsComponent } from './application-logs/view/view.component';

// app settings
import { APISettingsAdminComponent } from './settings/api-settings/admin.component';
import { LocationMappingComponent } from './location-mapping/location-mapping.component';

export const routes: Routes = [
    { path: 'dashboard', component: DashboardComponent, canActivate: [authGuard] },
    { path: 'application_logs', component: ViewApplicationLogsComponent, canActivate: [authGuard] },
    
    { path: 'settings/api_apps', component: APISettingsAdminComponent, canActivate: [authGuard] },
    { path: 'settings/location-mapping', component: LocationMappingComponent, canActivate: [authGuard] },

    {
        path: 'authentication',
        component: AuthenticationComponent,
        children: [
            { path: '', component: SignInComponent },
            { path: 'sign-up', component: SignUpComponent },
            { path: 'forgot-password', component: ForgotPasswordComponent },
            { path: 'reset-password', component: ResetPasswordComponent },
            { path: 'lock-screen', component: LockScreenComponent },
            { path: 'confirm-email', component: ConfirmEmailComponent },
            { path: 'logout', component: LogoutComponent }
        ]
    },
    { path: 'my-profile', component: MyProfileComponent, canActivate: [authGuard] },
    
    // Here add new pages component
    { path: '', redirectTo: '/authentication', pathMatch: 'full' },
    { path: '**', component: NotFoundComponent }, // This line will remain down from the whole pages component list
    { path: 'not-authorized', component: NotAuthorizedComponent }
];